// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"styles_modalFooter__JuFee","footerButton":"styles_footerButton__G7DJh","modalBody":"styles_modalBody__MQ50M","modalHeader":"styles_modalHeader__LmNn4"};